import { Dispatch, SetStateAction } from 'react';
import { Button } from '@/components/shadcn/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/shadcn/dialog';

interface Props {
  title: string;
  description: string;
  warning?: string;
  action: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onClick: (() => void) | null;
}

export default function ConfirmationModal({
  title,
  description,
  warning,
  action,
  open,
  setOpen,
  onClick,
}: Props) {
  return (
    <Dialog open={open}>
      <DialogContent className="max-w-[280px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
          {warning && (
            <DialogDescription className="text-xs">{warning}</DialogDescription>
          )}
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="dark"
            onClick={() => {
              setOpen(false);
            }}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onClick && onClick();
              setOpen(false);
            }}>
            {action}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
